<fieldset [formGroup]="group" class="in-one-column">
  <!-- <h6>{{ TITLE + "TITLE" | translate }}</h6> -->
  <!-- bitter properties are not in the specification yet -->
</fieldset>
